"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailRegex = exports.addressRegex = exports.TopicType = void 0;
var TopicType;
(function (TopicType) {
    // collector topics
    TopicType["COLLECTOR_TRANSACTIONAL"] = "COLLECTOR_TRANSACTIONAL";
    TopicType["COLLECTOR_REMINDER"] = "COLLECTOR_REMINDER";
    TopicType["COLLECTOR_NEW"] = "COLLECTOR_NEW";
    TopicType["COLLECTOR_EDIT"] = "COLLECTOR_EDIT";
    // creator topics
    TopicType["CREATOR_TRANSACTIONAL"] = "CREATOR_TRANSACTIONAL";
    TopicType["CREATOR_REMINDER"] = "CREATOR_REMINDER";
    TopicType["CREATOR_NEW"] = "CREATOR_NEW";
})(TopicType || (exports.TopicType = TopicType = {}));
exports.addressRegex = /^0x[a-fA-F0-9]{40}$/;
exports.emailRegex = /^\w+([\.-]?\w+)*(\+\w+)?@\w+([\.-]?\w+)*(\.\w{2,5})+$/;
//# sourceMappingURL=index.js.map